var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 1.93604C17.5463 1.6402 18.3597 2.45354 18.0638 3.3002L13.1263 17.4085C12.8055 18.3235 11.5305 18.3752 11.1372 17.4894L8.75468 12.1294L12.108 8.77521C12.2184 8.65673 12.2785 8.50002 12.2757 8.3381C12.2728 8.17619 12.2072 8.0217 12.0927 7.90719C11.9782 7.79268 11.8237 7.72708 11.6618 7.72423C11.4999 7.72137 11.3432 7.78147 11.2247 7.89187L7.87051 11.2452L2.51051 8.86271C1.62468 8.46854 1.67718 7.19437 2.59134 6.87354L16.6997 1.93604Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e0de77a66590b15113d767e46469095f.svg";
export { ForwardRef as ReactComponent };